var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew216({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.22,4.52a12.51,12.51,0,0,1,2-.15,4.09,4.09,0,0,1,2.89.89,3.28,3.28,0,0,1,1,2.57,3.77,3.77,0,0,1-1,2.77,4.4,4.4,0,0,1-3.16,1,13.1,13.1,0,0,1-1.67-.09Zm.92,6.31a4.93,4.93,0,0,0,.93.06,2.74,2.74,0,0,0,3-3c0-1.69-.94-2.76-2.89-2.76a4.68,4.68,0,0,0-1.08.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.28,4.52A8.48,8.48,0,0,1,11,4.37a2.93,2.93,0,0,1,2,.52,1.51,1.51,0,0,1,.6,1.26,1.71,1.71,0,0,1-1.21,1.57v0a1.84,1.84,0,0,1,1.47,1.79,1.91,1.91,0,0,1-.6,1.43,3.58,3.58,0,0,1-2.47.67,9.42,9.42,0,0,1-1.43-.09Zm.92,2.92H11c1,0,1.54-.51,1.54-1.19,0-.84-.63-1.17-1.56-1.17a4.2,4.2,0,0,0-.82.06Zm0,3.43a5.23,5.23,0,0,0,.77,0c1,0,1.84-.35,1.84-1.39S12,8.14,11,8.14H10.2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8,
    cy: 8,
    r: 7.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew216);
export default __webpack_public_path__ + "static/media/Symbolpack_New_216.f09eeb44d2ed95f23f3b4c7b225624e2.svg";
export { ForwardRef as ReactComponent };